import { cva } from 'class-variance-authority';
import { LoaderCircle } from 'lucide-react';
import { ButtonHTMLAttributes, MouseEventHandler } from 'react';
import { cn } from '../../util';
import { Icon } from '../Icon';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  variant: 'accent' | 'danger' | 'transparent' | 'noHover';
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  isLoading?: boolean;
  testId?: string;
};

const iconButtonVariants = cva(
  'flex justify-center items-center w-10 h-10 p-2 rounded-md border-0 cursor-pointer transition',
  {
    variants: {
      variant: {
        accent: 'bg-accent text-primary hover:opacity-70',
        transparent: 'bg-transparent text-light hover:bg-highlight',
        danger: 'bg-transparent text-light hover:bg-danger',
        noHover: 'bg-transparent text-light'
      },
      disabled: {
        false: null,
        true: 'pointer-events-none opacity-25 cursor-default'
      }
    },
    defaultVariants: {
      variant: 'transparent'
    }
  }
);

export const IconButton = ({ onClick, variant, icon, disabled, isLoading, testId, ...props }: IconButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
      className={cn(iconButtonVariants({ variant, disabled }))}
      {...props}
    >
      {!isLoading && <Icon size={'fillParent'} type={icon} />}
      {isLoading && <LoaderCircle className="animate-spin" />}
    </button>
  );
};
